export default {
    roomGroupId: 'default',
    roomGroups: {},
    viewType: 'read',
    noteId: null,
    logs: []
}
